import { FC } from 'react';
import { Route, RouteProps, useHistory } from 'react-router-dom';

interface ProtectedRouteProps extends RouteProps {
  isAllowed: boolean;
  showPermission?: boolean;
  reDirectPath?: string;
}

const ProtectedRoute: FC<ProtectedRouteProps> = (props: ProtectedRouteProps) => {
  const {
    component: Component,
    path,
    isAllowed,
    showPermission = false,
    reDirectPath = '/dashboard',
    children,
  } = props;

  const history = useHistory();

  if (isAllowed) {
    return (
      <Route component={Component} path={path}>
        {children}
      </Route>
    );
  }

  return (
    <>
      {history.push({
        pathname: reDirectPath,
        state: {
          showPermission,
        },
      })}
    </>
  );
};

export default ProtectedRoute;
